// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/connector.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { AppConnectorAccountCreationSchemaService } from "./connector";
import type { GetConnectorAccountCreationSchemaResponse } from "./connector";
import type { GetConnectorAccountCreationSchemaRequest } from "./connector";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { ConnectorService } from "./connector";
import type { UpdateConnectorScheduleResponse } from "./connector";
import type { UpdateConnectorScheduleRequest } from "./connector";
import type { EditorValidateResponse } from "./connector";
import type { EditorValidateRequest } from "./connector";
import type { GetConnectorSyncDownloadURLResponse } from "./connector";
import type { GetConnectorSyncDownloadURLRequest } from "./connector";
import type { ListConnectorSyncLifecycleResponse } from "./connector";
import type { ListConnectorSyncLifecycleRequest } from "./connector";
import type { ConnectorExternalSourceConfigSetRequest } from "./connector";
import type { ConnectorExternalSourceConfig } from "./connector";
import type { ConnectorExternalSourceConfigGetRequest } from "./connector";
import type { ListCompletedConnectorSyncLifecycleResponse } from "./connector";
import type { ListCompletedConnectorSyncLifecycleRequest } from "./connector";
import type { ConnectorSyncLifecycle } from "./connector";
import type { GetConnectorSyncLifecycleRequest } from "./connector";
import type { ConnectorServiceRevokeCredentialResponse } from "./connector";
import type { ConnectorServiceRevokeCredentialRequest } from "./connector";
import type { ConnectorServiceRotateCredentialResponse } from "./connector";
import type { ConnectorServiceRotateCredentialRequest } from "./connector";
import type { ConnectorServiceListCredentialsResponse } from "./connector";
import type { ConnectorServiceListCredentialsRequest } from "./connector";
import type { ConnectorServiceGetCredentialsResponse } from "./connector";
import type { ConnectorServiceGetCredentialsRequest } from "./connector";
import type { PauseSyncResponse } from "./connector";
import type { PauseSyncRequest } from "./connector";
import type { ConfirmSyncValidResponse } from "./connector";
import type { ConfirmSyncValidRequest } from "./connector";
import type { ResumeSyncResponse } from "./connector";
import type { ResumeSyncRequest } from "./connector";
import type { ForceSyncResponse } from "./connector";
import type { ForceSyncRequest } from "./connector";
import type { GetConnectorConfigFieldActivityResponse } from "./connector";
import type { GetConnectorConfigFieldActivityRequest } from "./connector";
import type { CreateAuthorizeURLResponse } from "./connector";
import type { CreateAuthorizeURLRequest } from "./connector";
import type { ConnectorServiceLogsResponse } from "./connector";
import type { ConnectorServiceLogsRequest } from "./connector";
import type { ConnectorServiceDeleteResponse } from "./connector";
import type { ConnectorServiceDeleteRequest } from "./connector";
import type { ConnectorServiceUpdateDelegatedRequest } from "./connector";
import type { ConnectorServiceUpdateAdvancedConfigRequest } from "./connector";
import type { ConnectorServiceUpdateSyncResourceTypesConfigRequest } from "./connector";
import type { ConnectorServiceUpdateAllowIgnoreListRequest } from "./connector";
import type { ConnectorServiceUpdateResponse } from "./connector";
import type { ConnectorServiceUpdateRequest } from "./connector";
import type { ConnectorServiceUploadResponse } from "./connector";
import type { ConnectorServiceUploadRequest } from "./connector";
import type { ConnectorServiceCreateDelegatedRequest } from "./connector";
import type { ConnectorServiceCreateResponse } from "./connector";
import type { ConnectorServiceCreateRequest } from "./connector";
import type { ConnectorServiceListResponse } from "./connector";
import type { ConnectorServiceListRequest } from "./connector";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { ConnectorServiceGetResponse } from "./connector";
import type { ConnectorServiceGetRequest } from "./connector";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.app.v1.ConnectorService
 */
export interface IConnectorServiceClient {
    /**
     * Get a connector.
     *
     * @generated from protobuf rpc: Get(c1.api.app.v1.ConnectorServiceGetRequest) returns (c1.api.app.v1.ConnectorServiceGetResponse);
     */
    get(input: ConnectorServiceGetRequest, options?: RpcOptions): UnaryCall<ConnectorServiceGetRequest, ConnectorServiceGetResponse>;
    /**
     * List connectors for an app.
     *
     * @generated from protobuf rpc: List(c1.api.app.v1.ConnectorServiceListRequest) returns (c1.api.app.v1.ConnectorServiceListResponse);
     */
    list(input: ConnectorServiceListRequest, options?: RpcOptions): UnaryCall<ConnectorServiceListRequest, ConnectorServiceListResponse>;
    /**
     * Create a configured connector.
     *
     * @generated from protobuf rpc: Create(c1.api.app.v1.ConnectorServiceCreateRequest) returns (c1.api.app.v1.ConnectorServiceCreateResponse);
     */
    create(input: ConnectorServiceCreateRequest, options?: RpcOptions): UnaryCall<ConnectorServiceCreateRequest, ConnectorServiceCreateResponse>;
    /**
     * Create a connector that is pending a connector config.
     *
     * @generated from protobuf rpc: CreateDelegated(c1.api.app.v1.ConnectorServiceCreateDelegatedRequest) returns (c1.api.app.v1.ConnectorServiceCreateResponse);
     */
    createDelegated(input: ConnectorServiceCreateDelegatedRequest, options?: RpcOptions): UnaryCall<ConnectorServiceCreateDelegatedRequest, ConnectorServiceCreateResponse>;
    /**
     * @generated from protobuf rpc: Upload(c1.api.app.v1.ConnectorServiceUploadRequest) returns (c1.api.app.v1.ConnectorServiceUploadResponse);
     */
    upload(input: ConnectorServiceUploadRequest, options?: RpcOptions): UnaryCall<ConnectorServiceUploadRequest, ConnectorServiceUploadResponse>;
    /**
     * Update a connector.
     *
     * @generated from protobuf rpc: Update(c1.api.app.v1.ConnectorServiceUpdateRequest) returns (c1.api.app.v1.ConnectorServiceUpdateResponse);
     */
    update(input: ConnectorServiceUpdateRequest, options?: RpcOptions): UnaryCall<ConnectorServiceUpdateRequest, ConnectorServiceUpdateResponse>;
    /**
     * @generated from protobuf rpc: UpdateAllowIgnoreList(c1.api.app.v1.ConnectorServiceUpdateAllowIgnoreListRequest) returns (c1.api.app.v1.ConnectorServiceUpdateResponse);
     */
    updateAllowIgnoreList(input: ConnectorServiceUpdateAllowIgnoreListRequest, options?: RpcOptions): UnaryCall<ConnectorServiceUpdateAllowIgnoreListRequest, ConnectorServiceUpdateResponse>;
    /**
     * @generated from protobuf rpc: UpdateConnectorSyncResourceTypesConfig(c1.api.app.v1.ConnectorServiceUpdateSyncResourceTypesConfigRequest) returns (c1.api.app.v1.ConnectorServiceUpdateResponse);
     */
    updateConnectorSyncResourceTypesConfig(input: ConnectorServiceUpdateSyncResourceTypesConfigRequest, options?: RpcOptions): UnaryCall<ConnectorServiceUpdateSyncResourceTypesConfigRequest, ConnectorServiceUpdateResponse>;
    /**
     * @generated from protobuf rpc: UpdateAdvancedConfig(c1.api.app.v1.ConnectorServiceUpdateAdvancedConfigRequest) returns (c1.api.app.v1.ConnectorServiceUpdateResponse);
     */
    updateAdvancedConfig(input: ConnectorServiceUpdateAdvancedConfigRequest, options?: RpcOptions): UnaryCall<ConnectorServiceUpdateAdvancedConfigRequest, ConnectorServiceUpdateResponse>;
    /**
     * Update a delegated connector.
     *
     * @generated from protobuf rpc: UpdateDelegated(c1.api.app.v1.ConnectorServiceUpdateDelegatedRequest) returns (c1.api.app.v1.ConnectorServiceUpdateResponse);
     */
    updateDelegated(input: ConnectorServiceUpdateDelegatedRequest, options?: RpcOptions): UnaryCall<ConnectorServiceUpdateDelegatedRequest, ConnectorServiceUpdateResponse>;
    /**
     * Delete a connector.
     *
     * @generated from protobuf rpc: Delete(c1.api.app.v1.ConnectorServiceDeleteRequest) returns (c1.api.app.v1.ConnectorServiceDeleteResponse);
     */
    delete(input: ConnectorServiceDeleteRequest, options?: RpcOptions): UnaryCall<ConnectorServiceDeleteRequest, ConnectorServiceDeleteResponse>;
    /**
     * @generated from protobuf rpc: Logs(c1.api.app.v1.ConnectorServiceLogsRequest) returns (c1.api.app.v1.ConnectorServiceLogsResponse);
     */
    logs(input: ConnectorServiceLogsRequest, options?: RpcOptions): UnaryCall<ConnectorServiceLogsRequest, ConnectorServiceLogsResponse>;
    /**
     * @generated from protobuf rpc: CreateAuthorizeURL(c1.api.app.v1.CreateAuthorizeURLRequest) returns (c1.api.app.v1.CreateAuthorizeURLResponse);
     */
    createAuthorizeURL(input: CreateAuthorizeURLRequest, options?: RpcOptions): UnaryCall<CreateAuthorizeURLRequest, CreateAuthorizeURLResponse>;
    /**
     * @generated from protobuf rpc: GetConnectorConfigFieldActivity(c1.api.app.v1.GetConnectorConfigFieldActivityRequest) returns (c1.api.app.v1.GetConnectorConfigFieldActivityResponse);
     */
    getConnectorConfigFieldActivity(input: GetConnectorConfigFieldActivityRequest, options?: RpcOptions): UnaryCall<GetConnectorConfigFieldActivityRequest, GetConnectorConfigFieldActivityResponse>;
    /**
     * @generated from protobuf rpc: ForceSync(c1.api.app.v1.ForceSyncRequest) returns (c1.api.app.v1.ForceSyncResponse);
     */
    forceSync(input: ForceSyncRequest, options?: RpcOptions): UnaryCall<ForceSyncRequest, ForceSyncResponse>;
    /**
     * @generated from protobuf rpc: ResumeSync(c1.api.app.v1.ResumeSyncRequest) returns (c1.api.app.v1.ResumeSyncResponse);
     */
    resumeSync(input: ResumeSyncRequest, options?: RpcOptions): UnaryCall<ResumeSyncRequest, ResumeSyncResponse>;
    /**
     * @generated from protobuf rpc: ConfirmSyncValid(c1.api.app.v1.ConfirmSyncValidRequest) returns (c1.api.app.v1.ConfirmSyncValidResponse);
     */
    confirmSyncValid(input: ConfirmSyncValidRequest, options?: RpcOptions): UnaryCall<ConfirmSyncValidRequest, ConfirmSyncValidResponse>;
    /**
     * @generated from protobuf rpc: PauseSync(c1.api.app.v1.PauseSyncRequest) returns (c1.api.app.v1.PauseSyncResponse);
     */
    pauseSync(input: PauseSyncRequest, options?: RpcOptions): UnaryCall<PauseSyncRequest, PauseSyncResponse>;
    /**
     * Get credentials for a connector.
     *
     * @generated from protobuf rpc: GetCredentials(c1.api.app.v1.ConnectorServiceGetCredentialsRequest) returns (c1.api.app.v1.ConnectorServiceGetCredentialsResponse);
     */
    getCredentials(input: ConnectorServiceGetCredentialsRequest, options?: RpcOptions): UnaryCall<ConnectorServiceGetCredentialsRequest, ConnectorServiceGetCredentialsResponse>;
    /**
     * @generated from protobuf rpc: ListCredentials(c1.api.app.v1.ConnectorServiceListCredentialsRequest) returns (c1.api.app.v1.ConnectorServiceListCredentialsResponse);
     */
    listCredentials(input: ConnectorServiceListCredentialsRequest, options?: RpcOptions): UnaryCall<ConnectorServiceListCredentialsRequest, ConnectorServiceListCredentialsResponse>;
    /**
     * Rotate credentials for a connector.
     *
     * @generated from protobuf rpc: RotateCredential(c1.api.app.v1.ConnectorServiceRotateCredentialRequest) returns (c1.api.app.v1.ConnectorServiceRotateCredentialResponse);
     */
    rotateCredential(input: ConnectorServiceRotateCredentialRequest, options?: RpcOptions): UnaryCall<ConnectorServiceRotateCredentialRequest, ConnectorServiceRotateCredentialResponse>;
    /**
     * Revoke credentials for a connector.
     *
     * @generated from protobuf rpc: RevokeCredential(c1.api.app.v1.ConnectorServiceRevokeCredentialRequest) returns (c1.api.app.v1.ConnectorServiceRevokeCredentialResponse);
     */
    revokeCredential(input: ConnectorServiceRevokeCredentialRequest, options?: RpcOptions): UnaryCall<ConnectorServiceRevokeCredentialRequest, ConnectorServiceRevokeCredentialResponse>;
    /**
     * Get current or last connector sync lifecycle.
     *
     * @generated from protobuf rpc: GetConnectorSyncLifecycle(c1.api.app.v1.GetConnectorSyncLifecycleRequest) returns (c1.api.app.v1.ConnectorSyncLifecycle);
     */
    getConnectorSyncLifecycle(input: GetConnectorSyncLifecycleRequest, options?: RpcOptions): UnaryCall<GetConnectorSyncLifecycleRequest, ConnectorSyncLifecycle>;
    /**
     * @generated from protobuf rpc: ListCompletedConnectorSyncLifecycle(c1.api.app.v1.ListCompletedConnectorSyncLifecycleRequest) returns (c1.api.app.v1.ListCompletedConnectorSyncLifecycleResponse);
     */
    listCompletedConnectorSyncLifecycle(input: ListCompletedConnectorSyncLifecycleRequest, options?: RpcOptions): UnaryCall<ListCompletedConnectorSyncLifecycleRequest, ListCompletedConnectorSyncLifecycleResponse>;
    /**
     * Get connectors external source config.
     *
     * @generated from protobuf rpc: GetConnectorExternalSourceConfig(c1.api.app.v1.ConnectorExternalSourceConfigGetRequest) returns (c1.api.app.v1.ConnectorExternalSourceConfig);
     */
    getConnectorExternalSourceConfig(input: ConnectorExternalSourceConfigGetRequest, options?: RpcOptions): UnaryCall<ConnectorExternalSourceConfigGetRequest, ConnectorExternalSourceConfig>;
    /**
     * Set connectors external source config
     *
     * @generated from protobuf rpc: SetConnectorExternalSourceConfig(c1.api.app.v1.ConnectorExternalSourceConfigSetRequest) returns (c1.api.app.v1.ConnectorExternalSourceConfig);
     */
    setConnectorExternalSourceConfig(input: ConnectorExternalSourceConfigSetRequest, options?: RpcOptions): UnaryCall<ConnectorExternalSourceConfigSetRequest, ConnectorExternalSourceConfig>;
    /**
     * ListConnectorSyncLifecycle method lists all lifecycle states immediately, without waiting for the sync lifecycle to complete.
     *
     * @generated from protobuf rpc: ListConnectorSyncLifecycle(c1.api.app.v1.ListConnectorSyncLifecycleRequest) returns (c1.api.app.v1.ListConnectorSyncLifecycleResponse);
     */
    listConnectorSyncLifecycle(input: ListConnectorSyncLifecycleRequest, options?: RpcOptions): UnaryCall<ListConnectorSyncLifecycleRequest, ListConnectorSyncLifecycleResponse>;
    /**
     * GetConnectorSyncDownloadURL generates a short-lived download URL for a completed connector sync artifact.
     *
     * @generated from protobuf rpc: GetConnectorSyncDownloadURL(c1.api.app.v1.GetConnectorSyncDownloadURLRequest) returns (c1.api.app.v1.GetConnectorSyncDownloadURLResponse);
     */
    getConnectorSyncDownloadURL(input: GetConnectorSyncDownloadURLRequest, options?: RpcOptions): UnaryCall<GetConnectorSyncDownloadURLRequest, GetConnectorSyncDownloadURLResponse>;
    /**
     * @generated from protobuf rpc: ValidateHTTPConnectorConfig(c1.api.app.v1.EditorValidateRequest) returns (c1.api.app.v1.EditorValidateResponse);
     */
    validateHTTPConnectorConfig(input: EditorValidateRequest, options?: RpcOptions): UnaryCall<EditorValidateRequest, EditorValidateResponse>;
    /**
     * @generated from protobuf rpc: UpdateConnectorSchedule(c1.api.app.v1.UpdateConnectorScheduleRequest) returns (c1.api.app.v1.UpdateConnectorScheduleResponse);
     */
    updateConnectorSchedule(input: UpdateConnectorScheduleRequest, options?: RpcOptions): UnaryCall<UpdateConnectorScheduleRequest, UpdateConnectorScheduleResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.ConnectorService
 */
export class ConnectorServiceClient implements IConnectorServiceClient, ServiceInfo {
    typeName = ConnectorService.typeName;
    methods = ConnectorService.methods;
    options = ConnectorService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Get a connector.
     *
     * @generated from protobuf rpc: Get(c1.api.app.v1.ConnectorServiceGetRequest) returns (c1.api.app.v1.ConnectorServiceGetResponse);
     */
    get(input: ConnectorServiceGetRequest, options?: RpcOptions): UnaryCall<ConnectorServiceGetRequest, ConnectorServiceGetResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorServiceGetRequest, ConnectorServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List connectors for an app.
     *
     * @generated from protobuf rpc: List(c1.api.app.v1.ConnectorServiceListRequest) returns (c1.api.app.v1.ConnectorServiceListResponse);
     */
    list(input: ConnectorServiceListRequest, options?: RpcOptions): UnaryCall<ConnectorServiceListRequest, ConnectorServiceListResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorServiceListRequest, ConnectorServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Create a configured connector.
     *
     * @generated from protobuf rpc: Create(c1.api.app.v1.ConnectorServiceCreateRequest) returns (c1.api.app.v1.ConnectorServiceCreateResponse);
     */
    create(input: ConnectorServiceCreateRequest, options?: RpcOptions): UnaryCall<ConnectorServiceCreateRequest, ConnectorServiceCreateResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorServiceCreateRequest, ConnectorServiceCreateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Create a connector that is pending a connector config.
     *
     * @generated from protobuf rpc: CreateDelegated(c1.api.app.v1.ConnectorServiceCreateDelegatedRequest) returns (c1.api.app.v1.ConnectorServiceCreateResponse);
     */
    createDelegated(input: ConnectorServiceCreateDelegatedRequest, options?: RpcOptions): UnaryCall<ConnectorServiceCreateDelegatedRequest, ConnectorServiceCreateResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorServiceCreateDelegatedRequest, ConnectorServiceCreateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Upload(c1.api.app.v1.ConnectorServiceUploadRequest) returns (c1.api.app.v1.ConnectorServiceUploadResponse);
     */
    upload(input: ConnectorServiceUploadRequest, options?: RpcOptions): UnaryCall<ConnectorServiceUploadRequest, ConnectorServiceUploadResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorServiceUploadRequest, ConnectorServiceUploadResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update a connector.
     *
     * @generated from protobuf rpc: Update(c1.api.app.v1.ConnectorServiceUpdateRequest) returns (c1.api.app.v1.ConnectorServiceUpdateResponse);
     */
    update(input: ConnectorServiceUpdateRequest, options?: RpcOptions): UnaryCall<ConnectorServiceUpdateRequest, ConnectorServiceUpdateResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorServiceUpdateRequest, ConnectorServiceUpdateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateAllowIgnoreList(c1.api.app.v1.ConnectorServiceUpdateAllowIgnoreListRequest) returns (c1.api.app.v1.ConnectorServiceUpdateResponse);
     */
    updateAllowIgnoreList(input: ConnectorServiceUpdateAllowIgnoreListRequest, options?: RpcOptions): UnaryCall<ConnectorServiceUpdateAllowIgnoreListRequest, ConnectorServiceUpdateResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorServiceUpdateAllowIgnoreListRequest, ConnectorServiceUpdateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateConnectorSyncResourceTypesConfig(c1.api.app.v1.ConnectorServiceUpdateSyncResourceTypesConfigRequest) returns (c1.api.app.v1.ConnectorServiceUpdateResponse);
     */
    updateConnectorSyncResourceTypesConfig(input: ConnectorServiceUpdateSyncResourceTypesConfigRequest, options?: RpcOptions): UnaryCall<ConnectorServiceUpdateSyncResourceTypesConfigRequest, ConnectorServiceUpdateResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorServiceUpdateSyncResourceTypesConfigRequest, ConnectorServiceUpdateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateAdvancedConfig(c1.api.app.v1.ConnectorServiceUpdateAdvancedConfigRequest) returns (c1.api.app.v1.ConnectorServiceUpdateResponse);
     */
    updateAdvancedConfig(input: ConnectorServiceUpdateAdvancedConfigRequest, options?: RpcOptions): UnaryCall<ConnectorServiceUpdateAdvancedConfigRequest, ConnectorServiceUpdateResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorServiceUpdateAdvancedConfigRequest, ConnectorServiceUpdateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update a delegated connector.
     *
     * @generated from protobuf rpc: UpdateDelegated(c1.api.app.v1.ConnectorServiceUpdateDelegatedRequest) returns (c1.api.app.v1.ConnectorServiceUpdateResponse);
     */
    updateDelegated(input: ConnectorServiceUpdateDelegatedRequest, options?: RpcOptions): UnaryCall<ConnectorServiceUpdateDelegatedRequest, ConnectorServiceUpdateResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorServiceUpdateDelegatedRequest, ConnectorServiceUpdateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delete a connector.
     *
     * @generated from protobuf rpc: Delete(c1.api.app.v1.ConnectorServiceDeleteRequest) returns (c1.api.app.v1.ConnectorServiceDeleteResponse);
     */
    delete(input: ConnectorServiceDeleteRequest, options?: RpcOptions): UnaryCall<ConnectorServiceDeleteRequest, ConnectorServiceDeleteResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorServiceDeleteRequest, ConnectorServiceDeleteResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Logs(c1.api.app.v1.ConnectorServiceLogsRequest) returns (c1.api.app.v1.ConnectorServiceLogsResponse);
     */
    logs(input: ConnectorServiceLogsRequest, options?: RpcOptions): UnaryCall<ConnectorServiceLogsRequest, ConnectorServiceLogsResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorServiceLogsRequest, ConnectorServiceLogsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateAuthorizeURL(c1.api.app.v1.CreateAuthorizeURLRequest) returns (c1.api.app.v1.CreateAuthorizeURLResponse);
     */
    createAuthorizeURL(input: CreateAuthorizeURLRequest, options?: RpcOptions): UnaryCall<CreateAuthorizeURLRequest, CreateAuthorizeURLResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateAuthorizeURLRequest, CreateAuthorizeURLResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetConnectorConfigFieldActivity(c1.api.app.v1.GetConnectorConfigFieldActivityRequest) returns (c1.api.app.v1.GetConnectorConfigFieldActivityResponse);
     */
    getConnectorConfigFieldActivity(input: GetConnectorConfigFieldActivityRequest, options?: RpcOptions): UnaryCall<GetConnectorConfigFieldActivityRequest, GetConnectorConfigFieldActivityResponse> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetConnectorConfigFieldActivityRequest, GetConnectorConfigFieldActivityResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ForceSync(c1.api.app.v1.ForceSyncRequest) returns (c1.api.app.v1.ForceSyncResponse);
     */
    forceSync(input: ForceSyncRequest, options?: RpcOptions): UnaryCall<ForceSyncRequest, ForceSyncResponse> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<ForceSyncRequest, ForceSyncResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ResumeSync(c1.api.app.v1.ResumeSyncRequest) returns (c1.api.app.v1.ResumeSyncResponse);
     */
    resumeSync(input: ResumeSyncRequest, options?: RpcOptions): UnaryCall<ResumeSyncRequest, ResumeSyncResponse> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<ResumeSyncRequest, ResumeSyncResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ConfirmSyncValid(c1.api.app.v1.ConfirmSyncValidRequest) returns (c1.api.app.v1.ConfirmSyncValidResponse);
     */
    confirmSyncValid(input: ConfirmSyncValidRequest, options?: RpcOptions): UnaryCall<ConfirmSyncValidRequest, ConfirmSyncValidResponse> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConfirmSyncValidRequest, ConfirmSyncValidResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: PauseSync(c1.api.app.v1.PauseSyncRequest) returns (c1.api.app.v1.PauseSyncResponse);
     */
    pauseSync(input: PauseSyncRequest, options?: RpcOptions): UnaryCall<PauseSyncRequest, PauseSyncResponse> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<PauseSyncRequest, PauseSyncResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get credentials for a connector.
     *
     * @generated from protobuf rpc: GetCredentials(c1.api.app.v1.ConnectorServiceGetCredentialsRequest) returns (c1.api.app.v1.ConnectorServiceGetCredentialsResponse);
     */
    getCredentials(input: ConnectorServiceGetCredentialsRequest, options?: RpcOptions): UnaryCall<ConnectorServiceGetCredentialsRequest, ConnectorServiceGetCredentialsResponse> {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorServiceGetCredentialsRequest, ConnectorServiceGetCredentialsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListCredentials(c1.api.app.v1.ConnectorServiceListCredentialsRequest) returns (c1.api.app.v1.ConnectorServiceListCredentialsResponse);
     */
    listCredentials(input: ConnectorServiceListCredentialsRequest, options?: RpcOptions): UnaryCall<ConnectorServiceListCredentialsRequest, ConnectorServiceListCredentialsResponse> {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorServiceListCredentialsRequest, ConnectorServiceListCredentialsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Rotate credentials for a connector.
     *
     * @generated from protobuf rpc: RotateCredential(c1.api.app.v1.ConnectorServiceRotateCredentialRequest) returns (c1.api.app.v1.ConnectorServiceRotateCredentialResponse);
     */
    rotateCredential(input: ConnectorServiceRotateCredentialRequest, options?: RpcOptions): UnaryCall<ConnectorServiceRotateCredentialRequest, ConnectorServiceRotateCredentialResponse> {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorServiceRotateCredentialRequest, ConnectorServiceRotateCredentialResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Revoke credentials for a connector.
     *
     * @generated from protobuf rpc: RevokeCredential(c1.api.app.v1.ConnectorServiceRevokeCredentialRequest) returns (c1.api.app.v1.ConnectorServiceRevokeCredentialResponse);
     */
    revokeCredential(input: ConnectorServiceRevokeCredentialRequest, options?: RpcOptions): UnaryCall<ConnectorServiceRevokeCredentialRequest, ConnectorServiceRevokeCredentialResponse> {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorServiceRevokeCredentialRequest, ConnectorServiceRevokeCredentialResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get current or last connector sync lifecycle.
     *
     * @generated from protobuf rpc: GetConnectorSyncLifecycle(c1.api.app.v1.GetConnectorSyncLifecycleRequest) returns (c1.api.app.v1.ConnectorSyncLifecycle);
     */
    getConnectorSyncLifecycle(input: GetConnectorSyncLifecycleRequest, options?: RpcOptions): UnaryCall<GetConnectorSyncLifecycleRequest, ConnectorSyncLifecycle> {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetConnectorSyncLifecycleRequest, ConnectorSyncLifecycle>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListCompletedConnectorSyncLifecycle(c1.api.app.v1.ListCompletedConnectorSyncLifecycleRequest) returns (c1.api.app.v1.ListCompletedConnectorSyncLifecycleResponse);
     */
    listCompletedConnectorSyncLifecycle(input: ListCompletedConnectorSyncLifecycleRequest, options?: RpcOptions): UnaryCall<ListCompletedConnectorSyncLifecycleRequest, ListCompletedConnectorSyncLifecycleResponse> {
        const method = this.methods[23], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListCompletedConnectorSyncLifecycleRequest, ListCompletedConnectorSyncLifecycleResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get connectors external source config.
     *
     * @generated from protobuf rpc: GetConnectorExternalSourceConfig(c1.api.app.v1.ConnectorExternalSourceConfigGetRequest) returns (c1.api.app.v1.ConnectorExternalSourceConfig);
     */
    getConnectorExternalSourceConfig(input: ConnectorExternalSourceConfigGetRequest, options?: RpcOptions): UnaryCall<ConnectorExternalSourceConfigGetRequest, ConnectorExternalSourceConfig> {
        const method = this.methods[24], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorExternalSourceConfigGetRequest, ConnectorExternalSourceConfig>("unary", this._transport, method, opt, input);
    }
    /**
     * Set connectors external source config
     *
     * @generated from protobuf rpc: SetConnectorExternalSourceConfig(c1.api.app.v1.ConnectorExternalSourceConfigSetRequest) returns (c1.api.app.v1.ConnectorExternalSourceConfig);
     */
    setConnectorExternalSourceConfig(input: ConnectorExternalSourceConfigSetRequest, options?: RpcOptions): UnaryCall<ConnectorExternalSourceConfigSetRequest, ConnectorExternalSourceConfig> {
        const method = this.methods[25], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorExternalSourceConfigSetRequest, ConnectorExternalSourceConfig>("unary", this._transport, method, opt, input);
    }
    /**
     * ListConnectorSyncLifecycle method lists all lifecycle states immediately, without waiting for the sync lifecycle to complete.
     *
     * @generated from protobuf rpc: ListConnectorSyncLifecycle(c1.api.app.v1.ListConnectorSyncLifecycleRequest) returns (c1.api.app.v1.ListConnectorSyncLifecycleResponse);
     */
    listConnectorSyncLifecycle(input: ListConnectorSyncLifecycleRequest, options?: RpcOptions): UnaryCall<ListConnectorSyncLifecycleRequest, ListConnectorSyncLifecycleResponse> {
        const method = this.methods[26], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListConnectorSyncLifecycleRequest, ListConnectorSyncLifecycleResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * GetConnectorSyncDownloadURL generates a short-lived download URL for a completed connector sync artifact.
     *
     * @generated from protobuf rpc: GetConnectorSyncDownloadURL(c1.api.app.v1.GetConnectorSyncDownloadURLRequest) returns (c1.api.app.v1.GetConnectorSyncDownloadURLResponse);
     */
    getConnectorSyncDownloadURL(input: GetConnectorSyncDownloadURLRequest, options?: RpcOptions): UnaryCall<GetConnectorSyncDownloadURLRequest, GetConnectorSyncDownloadURLResponse> {
        const method = this.methods[27], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetConnectorSyncDownloadURLRequest, GetConnectorSyncDownloadURLResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ValidateHTTPConnectorConfig(c1.api.app.v1.EditorValidateRequest) returns (c1.api.app.v1.EditorValidateResponse);
     */
    validateHTTPConnectorConfig(input: EditorValidateRequest, options?: RpcOptions): UnaryCall<EditorValidateRequest, EditorValidateResponse> {
        const method = this.methods[28], opt = this._transport.mergeOptions(options);
        return stackIntercept<EditorValidateRequest, EditorValidateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateConnectorSchedule(c1.api.app.v1.UpdateConnectorScheduleRequest) returns (c1.api.app.v1.UpdateConnectorScheduleResponse);
     */
    updateConnectorSchedule(input: UpdateConnectorScheduleRequest, options?: RpcOptions): UnaryCall<UpdateConnectorScheduleRequest, UpdateConnectorScheduleResponse> {
        const method = this.methods[29], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateConnectorScheduleRequest, UpdateConnectorScheduleResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.app.v1.AppConnectorAccountCreationSchemaService
 */
export interface IAppConnectorAccountCreationSchemaServiceClient {
    /**
     * @generated from protobuf rpc: Get(c1.api.app.v1.GetConnectorAccountCreationSchemaRequest) returns (c1.api.app.v1.GetConnectorAccountCreationSchemaResponse);
     */
    get(input: GetConnectorAccountCreationSchemaRequest, options?: RpcOptions): UnaryCall<GetConnectorAccountCreationSchemaRequest, GetConnectorAccountCreationSchemaResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.AppConnectorAccountCreationSchemaService
 */
export class AppConnectorAccountCreationSchemaServiceClient implements IAppConnectorAccountCreationSchemaServiceClient, ServiceInfo {
    typeName = AppConnectorAccountCreationSchemaService.typeName;
    methods = AppConnectorAccountCreationSchemaService.methods;
    options = AppConnectorAccountCreationSchemaService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Get(c1.api.app.v1.GetConnectorAccountCreationSchemaRequest) returns (c1.api.app.v1.GetConnectorAccountCreationSchemaResponse);
     */
    get(input: GetConnectorAccountCreationSchemaRequest, options?: RpcOptions): UnaryCall<GetConnectorAccountCreationSchemaRequest, GetConnectorAccountCreationSchemaResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetConnectorAccountCreationSchemaRequest, GetConnectorAccountCreationSchemaResponse>("unary", this._transport, method, opt, input);
    }
}
